import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionImage,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';

import PeopleDetailsSectionInfo from '../sections/PeopleDetailsSectionInfo';
import PeopleDetailsSectionSource from '../sections/PeopleDetailsSectionSource';

export default function PeopleDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<PeopleDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionDescription
							name="peop_descriptionhtml"
							value={props.model.peop_descriptionhtml}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					<Grid size={12}>
						<DetailsSectionNotes module="people" uid={props.model.peop_uid} />
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="clock-start" />}
							title={t('DETAILS_SOURCE_SECTION')}
							subheader={t('DETAILS_SOURCE_SUBHEADER')}
						>
							<PeopleDetailsSectionSource
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					{(props.isAdd || props.isEdit) && (
						<Grid size={12}>
							<DetailsSectionImage
								title={t('PEOPLE_AVATAR_SECTION')}
								subheader={t('PEOPLE_AVATAR_SUBHEADER')}
								isEdit
								fieldName="peop_avatar"
								fileName={props.model.peop_uid}
								path={`people\\${props.model.peop_uid}`}
								value={props.model.peop_avatar}
								grabberProps={{ defaultSearch: props.model.peop_title }}
								sendChange={props.sendFilesChange}
							/>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}
